// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"bde4d006","213":"c8f01d98","455":"d5f45d27","557":"57064989"}[chunkId] + ".chunk.js";
};